export const CART_STORAGE_KEY = 'al:cart:v1'
export const CART_VERSION = 1 as const
export const CART_TTL_DAYS = 30
export const CART_CHANGED_EVENT = 'al:cart:changed'

export type CartItem = {
  sku: string
  qty: number
  price: number
  name: string
  image?: string
  // Per-unit gross weight in kg, used to pick a shipping package on the
  // cart page (legacy logic — see Cart.tsx). 0 / undefined falls back to
  // weightless, which still works when the smallest package fits.
  weight?: number
  // SAP product filter code ('SP' = spare parts, 'PS' = paints/sprays).
  // Used by the cart to disable Delivery when paints are present (legacy
  // rule: paints/sprays can't be shipped).
  prodFilter?: string
}

export type Cart = {
  version: typeof CART_VERSION
  items: CartItem[]
  updatedAt: string
}

export const EMPTY_CART: Cart = {
  version: CART_VERSION,
  items: [],
  updatedAt: '1970-01-01T00:00:00.000Z',
}
